import * as React from "react";
const WeeklyMeetsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <mask
      id="aWeeklyMeetsIcon"
      width={20}
      height={21}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 .5h20v20H0z" />
    </mask>
    <g mask="url(#aWeeklyMeetsIcon)">
      <path
        fill={props.fill}
        d="M4.167 7.167h11.666V5.5H4.167v1.667Zm0 11.666c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.176V5.5c0-.458.163-.85.49-1.177.326-.326.718-.49 1.177-.49H5V2.167h1.667v1.666h6.666V2.167H15v1.666h.833c.459 0 .851.164 1.177.49.327.326.49.719.49 1.177v4.73a5.767 5.767 0 0 0-1.667-.5v-.897H4.167v8.334h5.25c.097.305.211.597.343.875.132.277.289.541.47.791H4.166ZM15 19.667c-1.153 0-2.135-.407-2.948-1.219-.812-.813-1.219-1.795-1.219-2.948s.407-2.135 1.22-2.948c.812-.812 1.794-1.219 2.947-1.219s2.135.407 2.948 1.22c.812.812 1.219 1.794 1.219 2.947s-.407 2.136-1.22 2.948c-.812.813-1.794 1.219-2.947 1.219Zm1.396-2.188.583-.583-1.562-1.563V13h-.834v2.667l1.813 1.812Z"
      />
    </g>
  </svg>
);
export default WeeklyMeetsIcon;
